export default __webpack_public_path__ + "static/media/Sourabh.206bc9ed.png";